import { render, staticRenderFns } from "./GetItem.vue?vue&type=template&id=8e3d8d44&scoped=true"
import script from "./GetItem.vue?vue&type=script&lang=js"
export * from "./GetItem.vue?vue&type=script&lang=js"
import style0 from "./GetItem.vue?vue&type=style&index=0&id=8e3d8d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3d8d44",
  null
  
)

export default component.exports